export default __webpack_public_path__ + "static/all-in-one-m-578e75537cc49dfeff3b49a734549aca.webp";